<template>
  <div>
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">
            Envelope Cost
          </h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <div class="os-icon os-icon-mail">
                      </div>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">
                        Envelope Cost
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-12 col-sm-12">
                <ResponseInfo v-if="getResponseInfo.responseName == 'envelopeCostView'" class="px-0"/>
                <b-table id="envelope-selling-price-table" responsive striped hover bordered :fields="fields" :busy.sync="loading" :items="envelopeCost" :show-empty="true">
                  <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="envelopeCost">
                    <vcl-table :rows="4" :columns="3"></vcl-table>
                  </template>
                  <template v-slot:cell(cost)="data">
                    <div class="input-group input-group-sm">
                      <b-form-input type="number" min="0.00" step="0.01" v-model="data.item.cost" class="form-control" />
                    </div>
                  </template>
                  <template v-slot:cell(actions)="data">
                    <div class="btn btn-sm btn-primary" @click="updateEnvelopeCost(data.item)">Update</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VclTable } from 'vue-content-loading'
import ResponseInfo from '@/components/ResponseInfo.vue'
import {mapGetters} from "vuex"

export default {
  name: 'EnvelopeSellingPrice',
  components: {
    VclTable,
    ResponseInfo
  },
  data() {
    return {
      fields: [
        {key: 'type', label: 'Envelope type', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'cost', label: 'Cost', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'currency', label: 'Currency', sortable: true, thClass: 'hover-pointer brand-color'},
        {key: 'actions', label: 'actions', sortable: true, thClass: 'hover-pointer brand-color'},
      ],
      loading: false,
    }
  },
  methods: {
    loadEnvelopeCost() {
      this.loading = true
      this.$store.dispatch('loadEnvelopeCost')
        .finally(() => {
          this.loading = false
        })
    },
    updateEnvelopeCost(item) {
      this.$store.dispatch('alertClearResponse')
      this.$store.dispatch('updateEnvelopeCost', {
        id: item.id,
        cost: item.cost,
      }).then(() => {
        let responseStatus = this.getResponseInfo.status
        if (responseStatus !== 'error') {
          this.loadEnvelopeCost()
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getResponseInfo']),
    envelopeCost: {
      get() {
        return this.$store.getters.getEnvelopeCost
      }
    },
  },
  created() {
    this.loadEnvelopeCost()
    this.$store.dispatch('alertClearResponse')
  },
}

</script>

<style scoped>

.table-responsive >>> tbody, .table-responsive >>> thead {
  text-align: center;
}

.table-responsive >>> .brand-color {
  background-color: #047bf8 !important;
  color: white !important;
}

</style>
